module.exports = __webpack_public_path__ + "static/media/logo.bd0a2390.svg";